// Copyright (c) 2017 Deere & Company

import React, {Component, PropTypes} from 'react';
import AccordionState from '../../../../shared/components/smart-accordion/state/accordion';
import CheckboxFilterControlled from '../../../../shared/components/facets/checkbox-filter/controlled';
import CheckboxWithSearchFilterControlled from '../../../../shared/components/facets/checkbox-with-search-filter/controlled';
import FacetFooter from '../../../../shared/components/facets/facet-footer/index';
import Facets from '../../state/facets';
import ReportLinks from '../../../../shared/components/report-links';
import {addCollectionLabels} from '../../../../shared/services/add-collection-labels';
import {create as createHashMap} from '../../../../shared/services/hashmap';
import {isDealerFacetInvalid} from '../../../../shared/services/facets';

function handleDealerAccountFacetItem(item, isSelected) {

    this.props.actions.updateDealerAccountFacetItem(item, isSelected);

}

function handleDealerFilterInput(text) {

    this.props.actions.updateDealerAccountFacetInput(text);

}

function toggleDealerAccountFacetItems() {

    this.props.actions.toggleDealerAccountFacetItems(this.props.facets.dealerAccountsFacet.allowedDealers);

}

function handleMetricFacetItem(item, isSelected) {

    this.props.actions.updateMetricFacetItem(item, isSelected);

}

function handlePipTypeFacetItem(item, isSelected) {

    this.props.actions.updatePipTypeFacetItem(item, isSelected);

}

function togglePipTypeFacetItems() {

    this.props.actions.togglePipTypeFacetItems(this.props.facets.pipTypesFacet.allowedTypes);

}

function toggleMetricsFacetItems() {

    this.props.actions.toggleMetricsFacetItems(this.props.facets.metricsFacet.allowedMetrics);

}

function toggleReportsAccordion() {

    this.props.actions.toggleReportsAccordion();

}

function handleApplyFilters() {

    if (!isDealerFacetInvalid(this.props.facets.dealerAccountsFacet)) {

        this.props.actions.readOpenPipProducts(this.props.facets);

    }

}

function handleResetFilters() {

    this.props.actions.resetAllFacets(
        this.props.facets.dealerAccountsFacet.allowedDealers,
        this.props.facets.metricsFacet.allowedMetrics,
        this.props.facets.pipTypesFacet.allowedTypes
    );

}

function facetsInvalid(facets) {

    return isDealerFacetInvalid(facets.dealerAccountsFacet) || facets.pipTypesFacet.selectedTypes.length === 0 || facets.metricsFacet.selectedMetrics.length === 0;

}

const loadAllDealers = dealerAccountsFacet => dealerAccountsFacet.isInitialLoad || dealerAccountsFacet.selectedDealers.length === 0;

class OpenPipsFacets extends Component {

    state = {
        dealerLocationExpanded: false,
        metricsExpanded: false,
        pipTypesExpanded: false
    };

    componentWillMount() {

        if (loadAllDealers(this.props.facets.dealerAccountsFacet)) {

            this.props.actions.selectAllDealersOnInitialLoad(this.props.facets.dealerAccountsFacet.allowedDealers);

        }

    }

    componentWillUnmount() {

        this.props.actions.resetAllFacets(
            this.props.facets.dealerAccountsFacet.allowedDealers,
            this.props.facets.metricsFacet.allowedMetrics,
            this.props.facets.pipTypesFacet.allowedTypes
        );

    }

    onAccordionToggle = accordionName => {

        this.setState({
            [accordionName]: !this.state[accordionName]
        });

    };

    anyFacetsOpen = () =>
        this.state.metricsExpanded || this.state.dealerLocationExpanded || this.state.pipTypesExpanded;

    render() {

        return (
            <aside>
                <div className='open-pips-facets'>
                    <CheckboxWithSearchFilterControlled
                        initialState={createHashMap(this.props.facets.dealerAccountsFacet.selectedDealers, 'account')}
                        isExpanded={this.state.dealerLocationExpanded}
                        list={addCollectionLabels(this.props.facets.dealerAccountsFacet.displayedDealers)}
                        minNumberOfItems={4}
                        onCheckboxListChange={this::handleDealerAccountFacetItem}
                        onClick={this.onAccordionToggle.bind(this, 'dealerLocationExpanded')}
                        onInputChange={this::handleDealerFilterInput}
                        onToggleAll={this::toggleDealerAccountFacetItems}
                        searchInput={this.props.facets.dealerAccountsFacet.searchInput}
                        searchPlaceholder='DEALER_LOCATION_FILTER'
                        title='DEALER_LOCATIONS'
                        valueKey={'account'}
                    />
                    <CheckboxFilterControlled
                        displayKey='value'
                        initialState={createHashMap(this.props.facets.pipTypesFacet.selectedTypes, 'key')}
                        isExpanded={this.state.pipTypesExpanded}
                        list={addCollectionLabels(this.props.facets.pipTypesFacet.allowedTypes, 'value')}
                        minNumberOfItems={4}
                        onChange={this::handlePipTypeFacetItem}
                        onClick={this.onAccordionToggle.bind(this, 'pipTypesExpanded')}
                        onToggleAll={this::togglePipTypeFacetItems}
                        title={'PIP_TYPES'}
                        valueKey={'key'}
                    />
                    <CheckboxFilterControlled
                        displayKey='value'
                        initialState={createHashMap(this.props.facets.metricsFacet.selectedMetrics, 'key')}
                        isExpanded={this.state.metricsExpanded}
                        list={addCollectionLabels(this.props.facets.metricsFacet.allowedMetrics, 'value')}
                        minNumberOfItems={4}
                        onChange={this::handleMetricFacetItem}
                        onClick={this.onAccordionToggle.bind(this, 'metricsExpanded')}
                        onToggleAll={this::toggleMetricsFacetItems}
                        title={'METRICS'}
                        valueKey={'key'}
                    />
                    {this.anyFacetsOpen() ?
                        <FacetFooter
                            disabled={facetsInvalid(this.props.facets)}
                            onApply={this::handleApplyFilters}
                            onReset={this::handleResetFilters}
                        /> : null}
                </div>
                <div className='report-links'>
                    <ReportLinks
                        accordion={this.props.reportsAccordion}
                        onAccordionToggle={this::toggleReportsAccordion}
                        parentRoute='pips'
                        routes={this.props.reportsRoutes}
                    />
                </div>
            </aside>
        );

    }

}

OpenPipsFacets.displayName = 'OpenPipsFacets';
OpenPipsFacets.propTypes = {
    actions: PropTypes.object.isRequired,
    facets: PropTypes.instanceOf(Facets),
    reportsAccordion: PropTypes.instanceOf(AccordionState).isRequired,
    reportsRoutes: PropTypes.object.isRequired
};

export default OpenPipsFacets;



// WEBPACK FOOTER //
// ./src/pip/open-pips/components/open-pips-aside/open-pips-facets.js